<template>
  <div class="term-container">
    <at-input
      v-model="search"
      type="search"
      placeholder="Слово..."
      prepend
      style="
        padding: 3px;
        background-color: rgb(255, 204, 0);
        margin: -3px;
        border-radius: 7px 7px 4px 4px;
      "
    >
      <template slot="prepend">
        <i class="icon icon-search"></i>
      </template>
    </at-input>
    <div class="term-content" id="termlist">
      <div
        v-for="term in limitedTerms"
        :key="term.id"
        style="margin-left: 6px"
        :id="`term_${term.id}`"
      >
        <at-checkbox
          v-model="term.selected"
          :label="term.id"
          @on-change="select(term)"
          >{{ term.name }}</at-checkbox
        >
        <div v-if="term.synShow">
          <div
            v-for="syn in term.syn"
            :key="syn.id"
            style="margin-left: 6px"
            :id="`term_${term.id}_syn_${syn.id}`"
          >
            <at-checkbox
              v-model="syn.selected"
              :label="syn.id"
              @on-change="select(syn)"
              >{{ syn.name }}</at-checkbox
            >
          </div>
        </div>
      </div>
      <at-button
        id="termListBottomFlag"
        v-if="$store.state.terms.termsLimit < terms.length"
        type="text"
        style="width: 100%"
        @click="$store.state.terms.termsLimit += 50"
        >Показать ещё</at-button
      >
    </div>
    <div class="term-footer">
      <at-button type="text" style="width: 100%" @click="synShow"
        >Показать синонимы</at-button
      >
      <at-button type="text" style="width: 50%" @click="selectAll(true)"
        >Выбрать все</at-button
      >
      <at-button type="text" style="width: 50%" @click="selectAll(false)"
        >Снять выбор</at-button
      ><br />
      <at-button
        type="text"
        style="width: 100%"
        @click="selectAll(false, { all: true })"
        >Снять выбор везде</at-button
      >
    </div>
  </div>
</template>

<script>
import { MapModules } from "@/MapModules";
export default {
  computed: {
    terms() {
      if (this.search != "") return this.$store.getters.getSearchResults;
      return this.$store.getters.termfilter;
    },
    limitedTerms() {
      return this.terms.slice(0, this.$store.state.terms.termsLimit);
    },
    search: {
      get() {
        return this.$store.getters.getSearch;
      },
      set(search) {
        this.$store.commit("setSearch", { search });
      },
    },
  },
  methods: {
    selectedTermsDel(term) {
      this.$store.commit('delTermFromTermsstack', term);
    },
    selectedTermsDelAll() {
      this.$store.state.terms.termstack = [];
    },
    selectedTermsAdd(term) {
      this.$store.state.terms.termstack.unshift(term);
    },
    synShow() {
      this.closenotify();
      var ids = [];
      this.limitedTerms.forEach((term) => {
        if (term.selected) {
          if (term.syn.length == 0) ids.push(term.id);
          term.synShow = true;
        }
      });
      this.$store.dispatch("getSynonyms", ids);
    },
    select(term) {
      this.$store.state.terms.lastId = term.id;
      this.$store.dispatch("rePrintPoints");
      term.synShow = false;
      if (term.selected) {
        this.closenotify();
        this.$store.dispatch("getTermDesc", term.id).then(() => {
          this.shownotify(term);
        });
        this.selectedTermsAdd(term);
      } else {
        this.selectedTermsDel(term);
      }
      
    },
    selectAll(val, options = { all: false }) {
      this.closenotify();
      if (options.all) {
        this.selectedTermsDelAll();
        this.$store.state.terms.filter.forEach((term) => {
          term.selected = val;
          term.synShow = false;
          if (val) this.selectedTermsAdd(term);
        });
      } else
        this.terms.forEach((term) => {
          term.selected = val;
          if (!val) this.selectedTermsDel(term);
          else {
            if(!this.$store.state.terms.termstack.find(t => t.id == term.id))
              this.selectedTermsAdd(term);
          }
          term.synShow = false;
        });
      if (val) this.$store.dispatch("rePrintPoints");
      else MapModules.removeAllPoints();
    },
    handleScroll() {
      if (document.getElementById("termListBottomFlag")) {
        var bottompos =
          document.getElementById("termlist").getBoundingClientRect().top +
          document.getElementById("termlist").clientHeight;
        var currentpos = document
          .getElementById("termListBottomFlag")
          .getBoundingClientRect().top;
        if (currentpos - bottompos < -10)
          this.$store.state.terms.termsLimit += 50;
      }
    },
    // закрытие всплывающего окна - информера
    closenotify() {
      this.$store.getters.getNotify.show = false;
    },
    // открытие всплывающего окна - информера
    shownotify(term) {
      var rex = /(<([^>]+)>)/gi;
      this.$store.getters.getNotify.show = true;
      this.$store.getters.getNotify.title = term.name;
      this.$store.getters.getNotify.content = term.description.replace(rex, "");
    },
  },
  mounted() {
    document
      .getElementById("termlist")
      .addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style>
.term-container {
  border: 1px solid #dfdfdf;
  border-radius: 4px;
}
.term-content {
  padding: 0;
  font-size: 13px;
  line-height: 1.5;
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100vh - 296px);
  margin-top: 3px;
}
.term-container input,
.term-container input:focus,
.term-container input:hover {
  border: 0;
  border-bottom: 1px solid #dfdfdf;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.term-container .at-btn:focus {
  outline: 0 !important;
}
.term-container .at-input-group__prepend {
  border: 0 !important;
  border-bottom: 1px solid #dfdfdf !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.term-footer {
  border-top: 1px solid #dfdfdf;
}
.at-notification {
  z-index: 5000 !important;
}

@media (max-width: 576px) {
  .term-content {
    height: calc(100vh - 220px);
  }
}
</style>
